import React from 'react'
import styles from './styles.css'
import ChevronRightIcon from './chevron-right.svg'
import classnames from 'classnames'
import { NavSellableTopListFragment } from '../categoryTopLists.generated'
import { format } from 'date-fns'
import useReactRouter from 'use-react-router'

interface Props {
  topList: NavSellableTopListFragment
  onTopListClicked: () => void
  className?: string
}

const TopListCard: React.FC<Props> = ({ topList, className, onTopListClicked }) => {
  const { friendlyId, slug, id, title } = topList
  const { history } = useReactRouter()

  return (
    <div
      className={classnames(className, styles.listLink)}
      onClick={() => {
        onTopListClicked()
        history.push(`/most-recommended/${friendlyId}/${slug}`)
      }}
      key={id}
    >
      <div className={styles.title}>
        <div className={styles.updatedAt}>Updated {format(topList.generatedAt, 'MM/dd/y')}</div>
        <div className={styles.content}>
          <div>{title} </div>
          <ChevronRightIcon height={12} width={7} className={styles.icon} />
        </div>
      </div>
    </div>
  )
}

export default TopListCard
